export const formatDateToString = (date: Date): string => {
  if (!date) {
    return '000-00-00 00:00:00.000';
  }

  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);
  const seconds = ('0' + date.getSeconds()).slice(-2);
  const milliseconds = ('00' + date.getMilliseconds()).slice(-3);

  return `${ year }-${ month }-${ day } ${ hours }:${ minutes }:${ seconds }.${ milliseconds }`;
}

export const getOneAndAHalfYearsFromNow = (): Date => {
  return new Date(new Date().setFullYear(new Date().getFullYear() + 1, new Date().getMonth() + 6))
}
